import { render } from "./BatchRegistrationUsers.vue?vue&type=template&id=7e882b9e&scoped=true"
import script from "./BatchRegistrationUsers.vue?vue&type=script&lang=js"
export * from "./BatchRegistrationUsers.vue?vue&type=script&lang=js"

import "./BatchRegistrationUsers.vue?vue&type=style&index=0&id=7e882b9e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e882b9e"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QSelect,QItem,QItemSection,QCheckbox,QSeparator,QFile,QIcon,QInnerLoading});
